/**
 * author: omarg
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var Config = require("registration-assets/config/config.json");
    var ApiResources = require("assets/data/apiResources.json");

    var AccountModel = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {
        AccountModel.HEADERS = {
            CONTENT_TYPE:'Content-Type',
            AUTHENTICATION_METHOD:'Authentication-Method',
            CREDIT_CARD_REF:'Credit-Card-Ref',
            AUTOMATION_SECRET:'Automation-Secret',
            EMAIL_TOKEN:'Email-Token'
        };

        AccountModel = BaseModel.extend({

            resource:ApiResources.Registration.Accounts,
            name: "AccountModel",
            defaults: {
                emailToken: "",
                email: "",
                firstName: "",
                lastName: "",
                website: "",
                password: "",
                location: "",
                industry: "",
                language: "",
                productName: "",
                ratePlanName: "",
                flow: "",
                currency: "" ,
                clickId: "",
                affiliateId: ""
            },

            savePaid: function(options){
                options = options || {};
                options.headers = {
                    'Content-Type': 'application/json',
                    'Authentication-Method': 'Credit-Card-Ref',
                    'Credit-Card-Ref': this.get("creditCardRef")
                };

                //TODO(oded): add roia cookie value as a param
                this.save(null, options);
            }
        });
    });

    return AccountModel;
});
